export default __webpack_public_path__ + "assets/images/2ec9a091377eff5b242478cf18cdf71e.png";